import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import uploadImage from "../../assests/images/Upload icon.png";
import Switch from "@mui/material/Switch";
import { UserObj } from "../../services/localStarage";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import { useNavigate } from "react-router-dom";
import { getSecPermission, isEmptyDash, returnValidVal, strToDate, strToDateYYMMDD, totalInr, trimString } from "../../constant";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { rfqServices } from "../../services/rfqServices";
import { lrServices } from "../../services/lrServices";
import { onboardingServices } from "../../services/onboardingServices";
import PackageDocuments from "../projectManagerScreens/packageDocuments";
import CustomSearchDropdown from "../common/customSearchDropdown";
import { commonServices } from "../../services/commonServices";
import Tooltip from '@mui/material/Tooltip';


const initialColumns = [
  { id: "productNumber", label: "Product ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Product Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "totalQuantity", label: "Total Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "deliveredQty", label: "Received Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "inTransitQty", label: "In-Transit Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "qcQty", label: "QC Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "balanceQty", label: "Balance Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
];
const shipmentdetailColumns = [
  { id: "poNumber", label: "Po No", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "productNumber", label: "Product ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Product Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "hsnSacCode", label: "HSN Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "qcQty", label: "QC Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "lrQty", label: "LR Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "INPUT_TEXT" },
  { id: "netPrice", label: "Rate", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "totalValue", label: "Total Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: " ", label: "Action", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DELETE" },
];

const transportDetailsArrInit = [
  { name: "transporterName", label: "Transporter Name", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "vehicleNumber", label: "Vehicle Number", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "driverName", label: "Driver Name", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "driverContactNumber", label: "Driver Contact Number", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "transporterLrNumber", label: "Transporter LR Number", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "transporterLrDate", label: "Transporter LR Date", isManadatory: true, value: "", formate: "INPUT_DATE", type: "date" },
  { name: "freightCharges", label: "Freight Charges", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "number" },
  { name: "shipmentVolume", label: "Total Shipment Volume", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "shipmentWeight", label: "Total Shipment Weight", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "eWayBillNo", label: "E-Way Bill No", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "eInvoiceNo", label: "E-Invoice No", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { name: "totalInvoiceAmount", label: "Total Invoice Amount", isManadatory: true, value: "", formate: "INPUT_TEXT", type: "number" },
];

const cloneSubmitObj = {
  "purchaseOrderIds": [],
  "products": [],
  "vendorId": "",
  "trackingNumber": "",
  "transporterName": "",
  "modeOfTransport": "",
  "vehicleNumber": "",
  "driverName": "",
  "driverContactNumber": "",
  "transporterLrNumber": "",
  "transporterLrDate": null,
  "freightCharges": 0,
  "shipmentVolume": "",
  "shipmentWeight": "",
  "eWayBillNo": "",
  "eInvoiceNo": "",
  "totalInvoiceAmount": 0,
  "origin": "",
  "destination": "",
  "expectedDeliveryDate": null,
  "specialInstructions": "",
  "documents": []
};

const productListInit = {
  totalPages: 0,
  currentPage: 1,
  totalItems: 0,
  products: [],
}

const existingVendorListInit = {
  totalPages: 0,
  currentPage: 1,
  totalItems: 0,
  vendors: [],
}

const pendingPOInit = {
  totalPages: 0,
  currentPage: 1,
  totalItems: 0,
  purchaseOrders: [],
}

const lrDocsArr = ["termSheet", "listOfConstructionMaterials", "vendorInformation", "generalConditions", "abacPolicy", "qualityRequirement", "approvedMakeList"];

function LrVendor() {
  const [dragging, setDragging] = useState(false);
  const userRole = UserObj ? UserObj?.role?.name : "";
  useEffect(() => {
    setChecked(false);
  }, []);
  // const [files, setFiles] = useState([]);
  // const label = { inputProps: { "aria-label": "Switch demo" } };
  // const qcListing = {
  //   currentPage: 1,
  //   totalPages : 20,
  // }
  const [columns, setColumns] = useState(initialColumns);
  const [columnshipment, setColumnshipment] = useState(shipmentdetailColumns);
  const [submitObj, setSubmitObj] = useState(cloneSubmitObj);


  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const fileInputRef = useRef([]);

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [pendingPO, setPendingPO] = React.useState(pendingPOInit);

  const [requestPayloadVendor, setRequestPayloadVendor] = useState(requestPayloadInitials);
  const [requestPayloadPO, setRequestPayloadPO] = useState(requestPayloadInitials);
  const [requestPayloadProduct, setRequestPayloadProduct] = useState(requestPayloadInitials);

  const [filterText, setFilterText] = useState("");
  const [selectedPOArr, setSelectedPOArr] = useState([]);
  const [productIdsToDelete, setProductIdsToDelete] = useState([]);
  const [filterFormData, setFilterFormData] = useState("");
  const [selectedPO, setSelectedPO] = useState("");
  const [selectedVendor, setSelectedVendor] = useState("");

  const [poProductsListing, setPOProductsListing] = React.useState(productListInit);
  const [existingVendorListing, setExistingVendorListing] = React.useState(existingVendorListInit);
  const [inputPage, setInputPage] = useState(poProductsListing?.currentPage || 1);

  const [transportDetailsArr, setTransportDetailsArr] = useState([]);
  const [documentArr, setDocumentArr] = useState([]); 
  const [selectedObj, setSelectedObj] = useState(null);
  const [routeDetails, setRouteDetails] = useState([]);
  const [uploadFilesObj, setUploadFilesObj] = useState({});
  const [lrDetails, setLRDetails] = useState({productIdsToDelete: []});
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [secLRPermission, setSecLRPermission] = useState({
    // "PURCHASE_ORDER_LISTING": permissionInit,
    // "PURCHASE_ORDER_DETAIL": permissionInit,
    // "WITH_ESIGN": permissionInit,
    // "ACCEPT": permissionInit,
    // "HOLD": permissionInit,

    // "REJECT": permissionInit,
    // "RELEASE": permissionInit,
    // "UNDO_RELEASE": permissionInit,
    // "TRACK_ORDER_PO": permissionInit,
    // "DOWNLOAD_PO": permissionInit,
  });
  const [isConfirmChecked, setIsConfirmChecked] = useState(false);


  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= poProductsListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(poProductsListing?.currentPage);
      }
    }
  };


  const getLRProductList = (id, requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=1&pageSize=999`;
    // if (requestPayloadParam.sortArray.length > 0) {
    //   param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    // }
    let promise = lrServices.getLRProductList(id, param);
    promise.then((res) => {
      if (res.data.success === true) {
        res?.data?.data?.products?.map((ele => {
          ele.lrQty = Number(ele.lrQuantity);
          ele.netPrice = Number(ele.rate);
        }))
        setSelectedPOArr(res?.data?.data?.products);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        // console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onSelectPOChange = (e) => {
    setSelectedPO(e.target.value);
  };

  const onSelectVendorChange = (e) => {
    setSelectedVendor(e.target.value);
    setSelectedPO("");
    setPendingPO(pendingPOInit);
    setPOProductsListing(productListInit);
  };

  // const handleDragEnter = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setDragging(true);
  // };

  // const handleDragLeave = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setDragging(false);
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  // };

  // const handleDrop = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setDragging(false);
  //   const droppedFiles = Array.from(e.dataTransfer.files);
  //   setFiles(droppedFiles);
  // };
  // const handleFileInputChange = (e) => {
  //   const selectedFiles = Array.from(e.target.files);
  //   setFiles(selectedFiles);
  // };

  const [checked, setChecked] = React.useState(true);

  const handleCheckChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

  };

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };

  useEffect(() => {
    if (userRole != "VENDOR") {
      getExistingVendorRfqList(requestPayloadPO, filterText, filterFormData);
    }
  }, [requestPayloadVendor]);

  useEffect(() => {
    getLRDocumentsList("P2P", "LR");
    if (userRole == "VENDOR") {
      getPendingPOListing(requestPayloadPO, filterText, filterFormData);
    }
  }, []);

  useEffect(() => {
    if (!isEmptyDash(selectedVendor)) {
      getPendingPOListing(requestPayloadPO, filterText, filterFormData);
    }
  }, [requestPayloadPO, selectedVendor]);

  useEffect(() => {
    if (!isEmptyDash(selectedPO)) {
      getPOProductsListing(requestPayloadProduct, filterText, filterFormData, selectedPO);
    }
  }, [requestPayloadProduct, selectedPO]);


  useEffect(() => {
    let secLRPermissionInit = _.cloneDeep(secLRPermission);
    let obj = {};
    for (let key in secLRPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecLRPermission(obj);

  }, []);

  const getPendingPOListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}&vendorId=${selectedVendor}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }

    let promise = purchaseOrderServices.getPendingPOListing(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setPendingPO(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const handleCheckboxInit = (e, data, index) => {
    const { checked } = e.target;
    const poProductsListingInit = _.cloneDeep(poProductsListing?.products);
    poProductsListingInit[index].isChecked = checked;
    setPOProductsListing((prevData) => ({ ...prevData, products: poProductsListingInit }));
  };

  const addRow = () => {
    let arr = [];
    const poProductsListingInit = _.cloneDeep(poProductsListing?.products);
    for (let i = 0; i < poProductsListingInit.length; i++) {
      let isValid = true;
      for (let j = 0; j < selectedPOArr.length; j++) {
        if (poProductsListingInit[i]?._id == selectedPOArr[j]?._id) {
          isValid = false;
        }
      }
      if (isValid && poProductsListingInit[i]?.isChecked) {
        arr.push(poProductsListingInit[i]);
      }
    }
    setSelectedPOArr((prevData) => ([...prevData, ...arr]));
  };

  const redirectToDetails = (redirectId) => {
    // const UserObjInit = JSON.parse(sessionStorage.getItem('user'));    
    // let param = {
    //   requestPayload: requestPayload,
    //   filterText: filterText,
    //   filterFormData: filterFormData,
    //   componentName: "LR_LIST",
    // };
    // UserObjInit["prevLocationData"] = param;
    // sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    // navigateUrl(`/admin/vendor-LR-Deatil/${redirectId}`);
  };

  const onFilterTextChange = (e) => {
    // let { value } = e.target;
    // setFilterText(value);
    // debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    // e.persist();
    // if (e.key === "Enter") {
    //   onFilterSubmit();
    // }
  };
  const onFilterSubmit = () => {
    // getPendingPOListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayloadPO);
      requestPayloadInit.pageNumber = 1;
      setRequestPayloadPO(requestPayloadInit);
    }, 800),
    []
  );

  const onSearchSelectChange = (param) => {
    // console.log(param);      
    setSelectedObj(param);
    
    setSelectedVendor(param?.selectedValue);
    setSelectedPO("");
    setPendingPO(pendingPOInit);
    setPOProductsListing(productListInit);
  }

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayloadProduct);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayloadProduct(requestPayloadInit);
    setColumns(columnsInit);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayloadProduct);
    requestPayloadInit.pageNumber = value;
    setRequestPayloadProduct(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayloadProduct);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayloadProduct(requestPayloadInit);
  }

  const getPOProductsListing = (requestPayloadParam, filterTextParam, formData, selectedPOId) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    // const filteredFormData = formData ? Object.entries(formData)
    //   .filter(([key, value]) => value !== '')
    //   .reduce((acc, [key, value]) => {
    //     acc[key] = value;
    //     return acc;
    //   }, {}) : {};
    // if (filteredFormData && Object.keys(filteredFormData).length > 0) {
    //   Object.entries(filteredFormData).forEach(([key, value]) => {
    //     param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    //   });
    // }

    let promise = purchaseOrderServices.getPOProductsListing(selectedPO, param);
    promise.then((res) => {
      if (res.data.success === true) {
        setPOProductsListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
        setPOProductsListing(productListInit);
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
        setPOProductsListing(productListInit);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getExistingVendorRfqList = (requestPayloadParam, filterTextParam) => {
    setIsLoading(true);
    let param = `?poExists=true&page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    rfqServices
      .getExistingVendorRfqListing(param)
      .then((res) => {
        if (res && res.data) {
          setExistingVendorListing(res?.data?.data)
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'No Data Found', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getFieldValue = (resData, fieldData) => {
    let val = "";
      if (fieldData?.static == true) {
        if (fieldData.type == "String" || fieldData.type == "Dropdown" || fieldData.type == "Number") {
          val = returnValidVal(resData[fieldData?.uniqueName], "");                
        }
        if (fieldData.type == "Date") {
          val = returnValidVal(strToDateYYMMDD(resData[fieldData?.uniqueName], ""));                
        }
        if (fieldData.type == "File") {
          val = getFileValue(resData[fieldData?.uniqueName]);                
        }
      }
      else {
        if (fieldData.type == "String" || fieldData.type == "Dropdown" || fieldData.type == "Number") {
          val = returnValidVal(resData["additionalFields"][fieldData?.uniqueName], "");                
        }
        if (fieldData.type == "Date") {
          val = returnValidVal(strToDateYYMMDD(resData["additionalFields"][fieldData?.uniqueName], ""));                
        }
        if (fieldData.type == "File") {
          val = getFileValue(resData["additionalFields"][fieldData?.uniqueName]);                
        }
      }
      return val;
  }
  
  const getDocumentValue = (resData, fieldData) => {
    let val = "";
      if (fieldData?.static == true) {
        if (fieldData.type == "File") {
          val = resData["documents"]?.filter((ele, i) => ele?.uniqueName == fieldData?.uniqueName)[0]["response"];                
        }
      }
      else {
        if (fieldData.type == "File") {
          val = resData["documents"]?.filter((ele, i) => ele?.uniqueName == fieldData?.uniqueName)[0]["response"];                    
        }
      }
      // console.log(val);
      
      return val;
  }

  const getFileValue = (data) => {
    // console.log(data); 
    return ""   
  }

  const getDetails = (param, fieldData) => {  
    setIsLoading(true);
    let url = `/${param}`;
    let promise = lrServices.getLRListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        getLRProductList(param);
        for (let j = 0; j < fieldData?.Transporter_Details.length; j++) {
          fieldData.Transporter_Details[j].value = getFieldValue(res.data?.data, fieldData?.Transporter_Details[j]);              
        }
        for (let j = 0; j < fieldData?.Route_Details.length; j++) {
          fieldData.Route_Details[j].value = getFieldValue(res.data?.data, fieldData?.Route_Details[j]);              
        }
        for (let j = 0; j < fieldData?.Documents.length; j++) {
          fieldData.Documents[j].response = getDocumentValue(res.data?.data, fieldData?.Documents[j]);              
        }
        // let transportDetailsArrInit = _.cloneDeep(transportDetailsArr);
        // let routeDetailsInit = _.cloneDeep(routeDetails);
        // let documentArrInit = _.cloneDeep(documentArr);
        // let obj = {
        //   "origin": res?.data?.data?.origin,
        //   "destination": res?.data?.data?.destination,
        //   "expectedDeliveryDate": strToDateYYMMDD(res?.data?.data?.expectedDeliveryDate),
        //   "specialInstructions": res?.data?.data?.specialInstructions,
        //   "lrNumber": res?.data?.data?.lrNumber,
        //   "_id": res?.data?.data?._id,
        // };
        // for (let i = 0; i < transportDetailsArrInit1.length; i++) {
        //   transportDetailsArrInit1[i].value = res?.data?.data[transportDetailsArrInit1[i].name];
        //   if (transportDetailsArrInit1[i].name == "transporterLrDate") {
        //     transportDetailsArrInit1[i].value = strToDateYYMMDD(res?.data?.data[transportDetailsArrInit1[i].name]);
        //   }
        // }
        setSelectedVendor(res?.data?.data?.vendorId);
        setSelectedObj({selectedLable: res?.data?.data?.vendorName, selectedValue: res?.data?.data?.vendorId})
        setLRDetails(res?.data?.data);
        setRouteDetails(fieldData?.Route_Details);
        setTransportDetailsArr(fieldData?.Transporter_Details);
        setDocumentArr(fieldData?.Documents);
        console.log(res?.data?.data, fieldData);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {        
        setDocumentArr(fieldData?.Documents);  
        setTransportDetailsArr(fieldData?.Transporter_Details); 
        setRouteDetails(fieldData?.Route_Details);  
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getLRDocumentsList = (moduleName, page) => {
    setIsLoading(true);
    let qParam = `?moduleName=${moduleName}&page=${page}`;
    let promise = commonServices?.getFieldConfig(qParam);
    // lrServices.getLRDocumentsList(param)
      promise.then((res) => {
        let obj = {};
        if (res.data.success === true) {
          for (let i = 0; i < res?.data?.data?.sections.length; i++) {
            if (res?.data?.data?.sections[i]?.title == "Documents") {
              let arr = res?.data?.data?.sections[i]?.fields;
              for (let j = 0; j < arr.length; j++) {
                arr[j]["documentName"] = arr[j]["name"];
                arr[j]["response"] = [];
              }
              obj["Documents"] = arr;        
            }
            if (res?.data?.data?.sections[i]?.title == "Transporter_Details") {
              let arr = res?.data?.data?.sections[i]?.fields;
              for (let j = 0; j < arr.length; j++) {
                arr[j]["formate"] = (arr[j]["type"] == "Number") ? "number" : (arr[j]["type"] == "Date") ? "date" : "text" ;
              }
              obj["Transporter_Details"] = arr;            
            }
            if (res?.data?.data?.sections[i]?.title == "Route_Details") {
              let arr = res?.data?.data?.sections[i]?.fields;
              for (let j = 0; j < arr.length; j++) {
                arr[j]["formate"] = (arr[j]["type"] == "Number") ? "number" : (arr[j]["type"] == "Date") ? "date" : "text" ;
              }
              obj["Route_Details"] = arr;           
            }
          }
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'No Data Found', });
        }

        return obj
      })
      .then((data) => {        
        const url = window.location.href;
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        const LRParam = params.get('lrId');
        // const QCCodeParam = params.get('qcId');
        if (!isEmptyDash(LRParam)) {
          getDetails(LRParam, data);
        }
        else {
          setDocumentArr(data?.Documents);  
          setTransportDetailsArr(data?.Transporter_Details); 
          setRouteDetails(data?.Route_Details);  
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const deleteRow = (idx) => {
    let selectedPOArrInit = _.cloneDeep(selectedPOArr);
    const updatedRows = [];
    for (let i = 0; i < selectedPOArrInit.length; i++) {
      if (i !== idx) {
        updatedRows.push(selectedPOArrInit[i]);
      }
      if (i == idx && !isEmptyDash(lrDetails?.lrNumber)) {        
        setProductIdsToDelete((prevData) => ([...prevData, selectedPOArrInit[i].productId]));
      }
      // if (i == idx && !isEmptyDash(lrDetails?.lrNumber)) {
      //   setLRDetails((prevData) => ({...prevData, productIdsToDelete:[...prevData?.productIdsToDelete, selectedPOArrInit[i].productId] }));
      //   // lrDetails["productIdsToDelete"] = selectedPOArr[i].productId;
      // }
    }
    
    setSelectedPOArr(updatedRows);
  };

  const onShipmentInputChange = (value, i) => {
    let selectedPOArrInit = _.cloneDeep(selectedPOArr);
    selectedPOArrInit[i]["lrQty"] = value;
    selectedPOArrInit[i]["totalValue"] = Number(value) * Number(selectedPOArrInit[i]["netPrice"]);
    setSelectedPOArr(selectedPOArrInit);
  };

  const onTransportInputChange = (e, secName, i, data) => {
    let { name, value } = e.target;
    if (secName == "Transport_Deatils") {
      let transportDetailsArrInit = _.cloneDeep(transportDetailsArr);
      transportDetailsArrInit[i]["value"] = value;
      setTransportDetailsArr(transportDetailsArrInit);
    }
    if (secName == "Route_Deatils") {
      let routeDetailsInit = _.cloneDeep(routeDetails);
      routeDetailsInit[i]["value"] = value;
      setRouteDetails(routeDetailsInit);
    }
  };

  const handleClick = (document, index) => {
    setUploadFilesObj(document);
    setIsMediaListModalOpen(true);
  }

  const handleButtonClick = (i) => {
    fileInputRef.current[i].click();
  };

  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };

  const onUploadMedia = (resData, uploadObj, files, data2) => {
    let obj = {
      key: encodeKey(resData?.data?.Key),
      fileName: files?.name,
    };
    uploadObj.response.push(obj);
    setUploadFilesObj(uploadObj);
  };

  const dummyFun = () => {

  };

  const deleteFile = (index, key, idx) => {
    let documentArrInitial = [...documentArr];
    const updatedFiles = uploadFilesObj.response.filter((file, i) => i !== index);

    for (let i = 0; i < documentArrInitial.length; i++) {
      if (documentArrInitial[i].uniqueName == uploadFilesObj?.uniqueName) {
        documentArrInitial[i].response = [...updatedFiles];
      }
    }
    setDocumentArr(documentArrInitial);
    const obj = { ...uploadFilesObj, response: [...updatedFiles] };
    setUploadFilesObj(obj);
  };

  const uploadFile = (e, document, index) => {
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0]
    const documentName = e.target?.dataset?.documentname;
    const uniqueName = e.target?.dataset?.uniquename;
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          setUrl(response?.data?.data, files, document, index);
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
        // openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

  const setUrl = (data, files, document, index) => {
    let documentArrInitial = [...documentArr];

    for (let i = 0; i < documentArrInitial.length; i++) {
      if (documentArrInitial[i]?.uniqueName == document?.uniqueName) {
        let fileObj = {
          key: encodeKey(data?.data?.Key),
          fileName: files?.name
        };
        documentArrInitial[i]?.response.push(fileObj);
      }
    }
    setDocumentArr(documentArrInitial);
  };

  const onConfirmCheckboxChange = (e) => {
    let { name, checked } = e.target;
    setIsConfirmChecked(checked);
  };

  const onSubmit = () => {
    let bodyData = {};
    let isValidObj = { valid: true, errMsg: "" };
    bodyData["vendorId"] = selectedVendor;
    bodyData["documents"] = documentArr;
    bodyData["additionalFields"] = {};
    // bodyData["destination"] = routeDetails["destination"];
    // bodyData["expectedDeliveryDate"] = routeDetails["expectedDeliveryDate"];
    // bodyData["specialInstructions"] = routeDetails["specialInstructions"];
    bodyData["products"] = [];
    bodyData["purchaseOrderIds"] = [];

    for (let i = 0; i < transportDetailsArr.length; i++) {
      if (transportDetailsArr[i].static == true) {
        bodyData[transportDetailsArr[i].uniqueName] = transportDetailsArr[i].value;
      } 
      else {
        bodyData["additionalFields"][transportDetailsArr[i].uniqueName] =  transportDetailsArr[i].value;
      }
      if (transportDetailsArr[i].required == true && isEmptyDash(transportDetailsArr[i].value)) {
        isValidObj["valid"] = false;
        isValidObj["errMsg"] = `Please enter ${transportDetailsArr[i].name}.`;
        break;
      }
    }
    
    for (let i = 0; i < routeDetails.length; i++) {
      if (routeDetails[i].static == true) {
        bodyData[routeDetails[i].uniqueName] = routeDetails[i].value;
      } 
      else {
        bodyData["additionalFields"][routeDetails[i].uniqueName] =  routeDetails[i].value;
      }
      if (routeDetails[i].required == true && isEmptyDash(routeDetails[i].value)) {
        isValidObj["valid"] = false;
        isValidObj["errMsg"] = `Please fill up all route details.`;
        break;
      }
    }

    for (let i = 0; i < selectedPOArr.length; i++) {
      let obj = {};
      if (isEmptyDash(lrDetails?.lrNumber)) {
        obj["productId"] = selectedPOArr[i]._id;
      } else {
        obj["productId"] = selectedPOArr[i].productId;
      }
      obj["purchaseOrderId"] = selectedPOArr[i].purchaseOrderId;
      obj["lrQty"] = Number(selectedPOArr[i].lrQty);

      bodyData.products.push(obj);
      bodyData.purchaseOrderIds.push(selectedPOArr[i].purchaseOrderId);
    }

    bodyData["purchaseOrderIds"] = [...new Set(bodyData["purchaseOrderIds"])];

    // if (isEmptyDash(routeDetails["origin"]) || isEmptyDash(routeDetails["destination"]) || isEmptyDash(routeDetails["expectedDeliveryDate"]) || isEmptyDash(routeDetails["specialInstructions"])) {
    //   isValidObj["valid"] = false;
    //   isValidObj["errMsg"] = `Please fill up all route details.`;
    // }

    if (isConfirmChecked != true) {
      isValidObj["valid"] = false;
      isValidObj["errMsg"] = `Please accept condition.`;
    }

    if (isValidObj.valid == false) {
      setAlertComponent({ open: true, type: 'error', message: `${isValidObj.errMsg}`, });
      return;
    }
    // console.log(bodyData);

    setIsLoading(true);

    let promise = "";
    if (isEmptyDash(lrDetails?.lrNumber)) {
      promise = lrServices.createLR(bodyData);
    } else {
      bodyData["productIdsToDelete"] = productIdsToDelete;
      promise = lrServices.updateLR(lrDetails?._id, bodyData);
    }
    
    promise.then((res) => {
      if (res.data.success === true) {
        setAlertComponent({ open: true, type: 'success', message: `${res.data?.message}`, });

        setRouteDetails([]);
        setTransportDetailsArr([]);
        setDocumentArr([]);
        navigateUrl(`/admin/vendor-Listing-Lr`);
      } else {
        setAlertComponent({ open: true, type: 'error', message: 'Error!', });
      }
    })
    .catch((error) => {
      setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse_div ms-auto">
            <div className="search_main">
              <h5 className="lr_creation">LR Creation Form</h5>
            </div>

            <div className="create_listing_project_div_bcfr">
              {/* <Switch
                checked={checked}
                onChange={handleCheckChange}
                inputProps={{ "aria-label": "controlled" }}
              /> */}
              {/* {userRole === "VENDOR" ? (
                <button class="create_btn_lr_creations">Modify LR</button>
              ) : null} */}
              {/* {userRole === "VENDOR" ? (
                <button class="create_btn_lr_creations">Cancel LR</button>
              ) : null} */}
            </div>
          </div>

          {checked === true ? (<>

            {/* For ASN */}
            <div id="first">
              <div>
                <div className="search_filter_outerse ms-auto">
                  <div className="search_mains">
                    <p className="asn_shipment_details_react_auto_reacts">
                      ASN and Shipment Details
                    </p>
                  </div>
                </div>
                <div className="lets_asn_react_shipment_details_autos_vendor">
                  <div className="required_react_vendor_blocks">
                    <label className="label_react_block_body_asn">
                      ASN Number
                    </label>
                    <div className="maine_row_detailqw_lr">
                      <input type="text" class="form-control vendor_lrsvalues" />
                      <button className="btn btn-outline-secondary">
                        <FilterAltIcon />
                        Destination
                      </button>
                    </div>
                  </div>
                  <div className="listing_main" style={{ overflowX: "scroll" }}>
                    <table>
                      <thead>
                        <tr>
                          <th className="vendor_tabels">
                            {/* <input type="checkbox" /> */}
                          </th>
                          <th className="vendor_tabels">ASN No</th>
                          <th className="vendor_tabels">ASN Date</th>
                          <th className="vendor_tabels">Destination</th>
                          <th className="vendor_tabels">ASN Qty</th>
                          <th className="vendor_tabels">ASN Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="maine_tr_vendor">
                          <td>
                            <input type="checkbox" />
                          </td>

                          <td className="block_solar">00701</td>
                          <td>12-01-2024</td>
                          <td>Gujarat </td>
                          <td>4</td>
                          <td>32,000</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td>
                            <input type="checkbox" />
                          </td>

                          <td className="block_solar">00701</td>
                          <td>12-01-2024</td>
                          <td>Gujarat </td>
                          <td>4</td>
                          <td>32,000</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="total_vendor_asn_react" colSpan={4}>
                            <p>Total</p>
                          </td>
                          <td className="total_vendor_asn_react_body">8</td>
                          <td className="total_vendor_asn_react_body">
                            64,000{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </>) : (<>
            {/* For Purchase Order */}
            <div id="second">
              <div className="psn_main_row_heading_lrcreation">
                <div>
                  <p className="psn_shipment_main_heading">
                    PO and Line-Item Details
                  </p>
                </div>
              </div>
              <div className="lrcreaction_detailmaine_rowq_value">
                <div className="lr_vendor_block_code_asvn">
                  <div>
                    {userRole === "BUYER" ? (
                      <div>
                        <label className="label_react_block_body_asn">
                          Vendor Code
                        </label>
                        {/* <select
                          class="form-select selected_lrcreactionpsnrow"
                          value={selectedVendor}
                          onChange={onSelectVendorChange}
                        >
                          <option value={""} disabled >Select</option>
                          {existingVendorListing?.vendors?.map((ele, i) => (
                            <>
                              <option value={ele?._id}>
                                {ele?.vendorCode}
                              </option>
                            </>
                          ))}

                        </select> */}
                        
                        <CustomSearchDropdown 
                                // column={initialColumns}
                                listingArrName="vendors"
                                onSearchSelectChange={onSearchSelectChange}
                                promiseRequest={rfqServices.getExistingVendorRfqListing}
                                extraPromiseParam="poExists=true"
                                additionalData={{
                                  lableKeyName1: "vendorName",
                                  lableKeyName2: "",
                                  valueKeyName: "_id",
                                }} 
                                // isDisable={(details?.assigneeId != UserObj?._id)}  
                                defaultValue={selectedObj}           
                              />
                      </div>
                    ) : null}

                    {/* <input type="text" class="form-control vendor_lrsvaluecreationfoem" value={""} /> */}
                  </div>
                  <div>
                    <label className="label_react_block_body_asn">
                      PO Number
                    </label>
                    <select
                      class="form-select selected_lrcreactionpsnrow"
                      value={selectedPO}
                      onChange={onSelectPOChange}
                    >
                      <option value={""} disabled>Select</option>
                      {pendingPO?.purchaseOrders?.map((ele, i) => (
                        <>
                          <option value={ele?._id}>
                            {ele?.poNumber}
                          </option>
                        </>
                      ))}
                    </select>
                  </div>
                  {/* <div class="container mt-3">
                  <label for="exampleSelect">Searchable Dropdown:</label>
                  <input class="form-control mb-2" id="searchInput" type="text" placeholder="Search..." />
                  <select class="form-select" id="exampleSelect" size="5">
                      <option value="1">Option 1</option>
                      <option value="2">Option 2</option>
                      <option value="3">Option 3</option>
                      <option value="4">Option 4</option>
                      <option value="5">Option 5</option>
                  </select>
              </div> */}
                </div>
                {userRole === "VENDOR" ? (
                  <div className="search_filter_outers ms-auto">
                    <div className="search_main">
                      <div id="custom-search-input">
                        <div className="input-group col-md-12">
                          <input
                            type="text"
                            className="form-control input-lg"
                            placeholder="Search here"
                            fdprocessedid="8achb"
                          />
                          <span className="input-group-btn">
                            <button
                              className="btn btn-info btn-lg"
                              type="button"
                              fdprocessedid="trsp06"
                            >
                              <span className="glyphicon glyphicon-search">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-search"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                                </svg>
                              </span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
             <div className="listing_main listing_main_dragdropcontext_body" style={{ width: "100%", overflow: "hidden" }}>
             <table className="">
             <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                      <tr>
                        <th className="vendor_tabels">
                          {/* <input type="checkbox" /> */}
                        </th>
                        {columns.map((column, index) => (<>
                          <th className="vendor_tabels ">
                            <div className="PoDetailTableHeading">
                              <div className="d-flex">
                                <p>{column?.label}</p>
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                  {(column.sortLabel != "asc") && <img src={topArrow} />}
                                  {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </div>
                            </div>
                          </th>
                        </>))}
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {poProductsListing?.products.length < 1 && <>
                        <tr>
                          <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}
                      {poProductsListing?.products?.map((productData, i) => (<>
                        <tr className="maine_tr_vendor">
                          <td>
                            <input type="checkbox" onChange={(e) => handleCheckboxInit(e, productData, i)} checked={productData?.isChecked} />
                          </td>
                          {columns.map((column, j) => (column?.formate == "TEXT") ? <td>
                            <Tooltip title={productData[column.id] || "N/A"}>
                                  {productData[column.id] ? trimString(productData[column.id], 20) : "N/A"}
                                 </Tooltip>
                            {/* {productData[column?.id]} */}
                            </td> : (column?.formate == "DATE") ? 
                          <td>{strToDate(productData[column?.id])}</td> : null)}
                        </tr>
                      </>))}
                      {/* <tr className="maine_tr_vendor">
                      <td>
                        <input type="checkbox" />
                      </td>

                      <td className="block_solar">00701</td>
                      <td>Chinese masala</td>
                      <td>1000</td>
                      <td>200</td>
                      <td>700</td>
                      <td>100</td>
                      <td>60</td>
                    </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>

              {(poProductsListing?.products.length > 0) && <div className="lets_pagination_package_listing_vendor_button">
                <div className="pagination_select_react_packagelr_detail">
                  <span className="react_text_showing">
                    Items per page:
                  </span>
                  <select
                    className="form-select packagelrlisting from-hs"
                    onChange={onPageSizeChange}
                    value={requestPayloadProduct?.pageSize}
                  >
                    <option selected="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <span className="react_text_showing">
                    {` Showing rows ${Number(poProductsListing?.pageSize) * Number(poProductsListing?.currentPage - 1) + 1} to ${Number(poProductsListing?.pageSize) * Number(poProductsListing?.currentPage - 1) + Number(poProductsListing?.products?.length)} of ${poProductsListing?.totalItems}`}
                  </span>
                </div>
                <Stack spacing={2}>
                  <Pagination
                    count={poProductsListing?.totalPages}
                    page={poProductsListing?.currentPage}
                    onChange={(event, page) => {
                      setInputPage(page);
                      onPaginationChange(event, page);
                    }}
                    renderItem={(item) => {
                      if (item.page === poProductsListing?.currentPage) {
                        return (
                          <input
                            className="form-control form-hasw"
                            type="text"
                            value={inputPage}
                            onChange={handleInputChange}
                            onKeyDown={handleInputSubmit}
                            style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                          />
                        );
                      }
                      return (
                        <PaginationItem
                          className="pagination_react_listings"
                          slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                          {...item}
                        />
                      );
                    }}

                  />
                </Stack>
              </div>}

              <div style={{ marginTop: "20px" }}>
                <button className="btn btn-primary btn-sm" onClick={addRow}>Add Item</button>
              </div>
              <div className="search_mains">
                <div className="shipmentdetail_border">
                  <p className="psn_shipment_main_heading">Shipment Details</p>
                </div>
              </div>
              <div className="search_filter_outers ms-auto">
                <div className="search_main">
                  <div id="custom-search-input">
                    <div className="input-group col-md-12">
                      <input
                        type="text"
                        className="form-control input-lg"
                        placeholder="Search here"
                        fdprocessedid="8achb"
                      />
                      <span className="input-group-btn">
                        <button
                          className="btn btn-info btn-lg"
                          type="button"
                          fdprocessedid="trsp06"
                        >
                          <span className="glyphicon glyphicon-search">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", overflow: "hidden" }}
                className="listing_main listing_main_dragdropcontext_body listingmain">
                <table>
                  <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                    <tr>
                      <th className="vendor_tabels">
                        {/* <input type="checkbox" /> */}
                      </th>
                      {columnshipment.map((column, index) => (<>
                        <th className="vendor_tabels ">
                          <div className="PoDetailTableHeading">
                            <div className="d-flex">
                              <p>{column?.label}</p>
                              {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                {(column.sortLabel != "asc") && <img src={topArrow} />}
                                {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                              </span>}
                            </div>
                          </div>
                        </th>
                      </>))}
                    </tr>
                  </thead>
                  <tbody style={{ overflowY: "scroll", width: "200px" }}>
                    {selectedPOArr.length < 1 && <>
                      <tr>
                        <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                      </tr>
                    </>}
                    {selectedPOArr?.map((productData, i) => (<>
                      <tr className="maine_tr_vendor">
                        <td>
                          <input type="checkbox" />
                        </td>
                        {columnshipment.map((column, j) => (column?.formate == "TEXT") ?
                          <td>
                            {/* {productData[column?.id]} */}
                               <Tooltip title={productData[column.id] || "N/A"}>
                                  {productData[column.id] ? trimString(productData[column.id], 20) : "N/A"}
                                 </Tooltip>
                          </td> : (column?.formate == "INPUT_TEXT") ?
                            <td>
                                <Tooltip title={productData?.lrQty}>
                              <input type="number" className="form-control form-ha" onChange={(e) => onShipmentInputChange(e.target.value, i)} 
                              // value={productData?.lrQty}
                              value={trimString(productData?.lrQty || "", 20)}
                              />
                              </Tooltip>
                            </td> : (column?.formate == "DELETE") ?
                              <td> <HighlightOffIcon className="highlight_close_btn" onClick={() => deleteRow(i)} /> </td> : (column?.formate == "RATE") ?
                                <td> ₹{totalInr(isEmptyDash(productData[column?.id]) ? 0 : productData[column?.id])} </td> : (column?.formate == "DATE") ?
                                  <td>{strToDate(productData[column?.id])}
                                  </td> : null)}
                      </tr>
                    </>))}

                    {/* <tr className="maine_tr_vendor">
                    <td>
                      <input type="checkbox" />
                    </td>
                    <td className="block_solar">00702</td>
                    <td className="block_solar">00702</td>
                    <td>Chinese masala</td>
                    <td>HSN5434</td>
                    <td>234</td>
                    <td><input type="text" class="form-control form-ha" /></td>
                    <td>₹3,500</td>
                    <td>
                      <div className="lets_helih_icon">
                      ₹24,000
                      <HighlightOffIcon className="icon_close_control"/>
                      </div>
                    </td>
                  </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </>)}

          <div>
            <div className="search_filter">
              <div className="search_mains">
                <p className="psn_shipment_main_heading_detail">
                Transporter Details and LR Information
                </p>
              </div>
            </div>
            <div className="lets_asn_react_shipment_details_autos_vendor">
              <div className="div-create-trans-LR">
                {transportDetailsArr?.map((fieldData, i) => (<>
                  {(fieldData?.display == true) && <div className="col-sm-4" style={{ padding: "10px" }}>
                    <label className="label_react_block_body_asn">
                      {fieldData?.name}:
                      {(fieldData?.required) && <span className="required">*</span>}
                    </label>
                    {(fieldData?.type == "String" || fieldData?.type == "Number" || fieldData?.type == "Date") && <div className="lets_asn_block_body_required_number">
                      <Tooltip title={fieldData?.value}>
                      <input name={fieldData?.name} type={fieldData?.formate} className="form-control vendor_lrsvalue"
                      //  value={fieldData?.value}    
                       value={trimString(fieldData?.value || "", 35)} onChange={(e) => onTransportInputChange(e, "Transport_Deatils", i, fieldData)} />
                       </Tooltip>
                    </div>}
                  </div>}
                </>))}
              </div>
            </div>
          </div>
          <div>
            <div className="search_filter">
              <div className="search_mains">
                <p className="psn_shipment_main_heading">
                  Route Details and Additional Information
                </p>
              </div>
            </div>
            <div className="lets_asn_react_shipment_details_autos_vendor">
              <div className="lets_vendor_lrsvalue_details_block_asn">

                {routeDetails?.map((fieldData, i) => (<>
                  {(fieldData?.display == true) && <div className="required_react_vendor_block" >
                    <label className="label_react_block_body_asn">
                      {fieldData?.name}:
                      {(fieldData?.required) && <span className="required">*</span>}
                    </label>
                    {(fieldData?.type == "String" || fieldData?.type == "Number" || fieldData?.type == "Date") && <div className="lets_asn_block_body_required_number">
                      <Tooltip title={fieldData?.value}>
                      <input name={fieldData?.name} type={fieldData?.formate} className="form-control vendor_lrsvaluesvalue" 
                      // value={fieldData?.value}
                      value={trimString(fieldData?.value || "", 20)} 
                       onChange={(e) => onTransportInputChange(e, "Route_Deatils", i, fieldData)} />
                       </Tooltip>
                    </div>}
                  </div>}
                </>))}

                              {/* <div className="required_react_vendor_block">
                                <label className="label_react_block_body_asn">
                                  Origin :
                                </label>
                                <span className="required">*</span>
                                <div className="lets_asn_block_body_required_number">
                                  <input name="origin" type="text" class="form-control vendor_lrsvaluesvalue" value={routeDetails?.origin} onChange={(e) => onTransportInputChange(e, "Route_Deatils")} />
                                </div>
                              </div>
                              <div className="required_react_vendor_block">
                                <label className="label_react_block_body_asn">
                                  Destination :
                                </label>
                                <span className="required">*</span>
                                <div className="lets_asn_block_body_required_number">
                                  <input name="destination" type="text" class="form-control vendor_lrsvaluesvalue" value={routeDetails?.destination} onChange={(e) => onTransportInputChange(e, "Route_Deatils")} />
                                </div>
                              </div>
                              <div className="required_react_vendor_block">
                                <label className="label_react_block_body_asn">
                                  Expected Delivery Date:
                                </label>
                                <span className="required">*</span>
                                <div className="lets_asn_block_body_required_number">
                                  <input name="expectedDeliveryDate" type="date" class="form-control vendor_lrsvaluesvalue" value={routeDetails?.expectedDeliveryDate} onChange={(e) => onTransportInputChange(e, "Route_Deatils")} />
                                </div>
                              </div> */}
              </div>



              {/* <div className="lets_vendor_lrsvalue_details_block_asn_react_body_block ">
                <div className="required_react_vendor_block">
                  <label className="label_react_block_body_asn">
                    Special Instructions:
                  </label>
                  <span className="required">*</span>
                  <div className="lets_asn_block_body_required_number">
                    <textarea
                      name="specialInstructions"
                      type="text"
                      class="form-control vendor_lrsvaluesvalue"
                      value={routeDetails?.specialInstructions}
                      onChange={(e) => onTransportInputChange(e, "Route_Deatils")}
                    />
                  </div>
                </div>
              </div> */}

              <div className="special_instrustion_vendor_lrsvalue">
                <div className="required_react_vendor_block">
                  <label className="label_react_block_body_asn">
                    Documents Attached:
                  </label>
                  <span className="required">*</span>
                </div>
              </div>
              <div class="listing_block_maine_allbtn">
                <div className="package_detail_allbtn_projectmanager2" style={{ paddingLeft: "20px" }} >

                  {documentArr?.map((document, index) => (
                    <>
                      <div>
                        <p className="package_projectmanager">{trimString(document?.name, 20)}
                        {(document?.required) && <span className="required">*</span>}
                        </p>
                        {(!isEmptyDash(document.response[0]?.key)) && <>
                          <div className="selected-file-present-div" style={{ display: 'inline' }}>{ }
                            <span className="selected-file-present-text">Document: {document?.response?.length} </span>
                          </div>
                          <button className="file-upload-btn" disabled=""
                            onClick={() => handleClick(document, index)}
                          >View</button>
                        </>
                        }

                        {(isEmptyDash(document.response[0]?.key)) && <>
                          <div className="lets_block_package_listing_bom_file" style={isEmptyDash(document.response[0]?.key) ? { display: 'block' } : { display: 'none' }}>
                            <div>
                              <button className="upload_file_bom_tendor_project_react"
                                onClick={() => handleButtonClick(index)}
                              // htmlFor={`ref${index}`}
                              >
                                <CloudUploadIcon className="download_icon_react" />
                                Upload File
                              </button>
                              <input
                                type="file"
                                // ref={fileInputRef}
                                ref={(element) => fileInputRef.current[index] = element}
                                id={`ref${index}`}
                                style={{ display: "none" }}
                                onChange={(e) => uploadFile(e, document, index)}
                                accept={ isEmptyDash(document?.validation) ? "" : document?.validation[0]?.fileTypes }
                              />
                            </div>
                          </div>
                        </>}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="lets_block_react_upload_checkbox">
            <input type="checkbox" checked={isConfirmChecked} onChange={onConfirmCheckboxChange} />
            <p className="text_checkbox_body">
            I confirm all required documents and details have been uploaded correctly.
            </p>
          </div>
          <div className="submit_btn_forn_lr">
            <button
              type="button"
              class="btn cancel_btnform"
              onclick="clearForm()"
              fdprocessedid="ljipg"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-success save_next_btn"
              onclick="validateForm()"
              fdprocessedid="zk7zm"
              onClick={onSubmit}
            >
              Submit
            </button>
          </div>

        </div>
      </div>

      <PackageDocuments
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={uploadFilesObj}
        onUploadMedia={onUploadMedia}
        deleteFile={deleteFile}
        isSubmitCondition={false} //{userRole == "BUYER"}
        onMediaActionChange={dummyFun}
        acceptAcknowledge={false}
        isColumn={{
          "DELETE": true,
          "INPUT_UPLOAD": true,
          // "INPUT_UPLOAD": getRFQDocPermission(uploadFilesObj)?.update,
          "STATUS": false,
          "VENDOR_DOC": false,
          "REMARKS": false,
        }}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default LrVendor;
